import store from "@src/reducers/store";
import { putUpdateDashboardTiles } from "./put-update-dashboard-tiles";
import { postCreateDashboardTiles } from "./post-create-dashboard-tiles";

export const transferDashboardTilesDataToClient = async (
  dashboardId,
  dashboardDataTiles,
) => {
  const source_id = store.getState().yourSlice.connectionView.source.source_id;
  const namespace = store.getState().yourSlice.authContext.customerNamespace;

  return dashboardId
    ? await putUpdateDashboardTiles(
        dashboardId,
        source_id,
        namespace,
        dashboardDataTiles,
      )
    : await postCreateDashboardTiles(source_id, namespace, dashboardDataTiles);
};
